<template>
  <div>
    <el-divider></el-divider>
    <div class="grid-control">
      <div class="main-control" style="margin-bottom: 15px;">
        时间选择: 
        <el-checkbox style="margin-right: 10px;" v-model="timeMode" >跟随全局</el-checkbox>

        <div>
          <el-radio-group size="mini" v-model="time_type_local" :disabled="timeMode">
            <el-radio-button label="hour">小时</el-radio-button>
            <el-radio-button label="week">周</el-radio-button>
          </el-radio-group>

          

          <div style="margin: 5px 0;">
            <el-date-picker
              :disabled="timeMode"
              v-show="time_type_local === 'hour'"
              size="mini"
              format="yyyy-MM-dd HH"
              v-model="line_t_local"
              type="datetime"
              placeholder="选择日期时间">
            </el-date-picker>

            <el-date-picker
              :disabled="timeMode"
              v-show="time_type_local === 'week'"
              size="mini"
              format="yyyy-MM-dd"
              v-model="line_t_local"
              type="date"
              placeholder="选择日期时间">
            </el-date-picker>

            <el-button-group size="mini" >
              <el-button :disabled="timeMode" @click="handleTm(-1)" size="mini" type="primary" icon="el-icon-arrow-left"></el-button>
              <el-button :disabled="timeMode" @click="handleTm(1)" size="mini" type="primary"><i class="el-icon-arrow-right el-icon--right"></i></el-button>
            </el-button-group>
          </div>
          
        </div>  
        <div class="main-control">
            显示网格值：
            <el-switch
              v-model="showGridName">
            </el-switch>
          </div>
      </div>
      <div class="main-control">
        <el-checkbox style="margin-right: 10px;" v-model="showLayer1" :disabled="isNotPm">超标浓度高</el-checkbox>
      </div>
      <div class="main-control">
        <el-checkbox style="margin-right: 10px;" v-model="showLayer2" :disabled="isNotPm">超限值小时数多</el-checkbox>
      </div>
      <el-divider></el-divider>

      
      <div class="main-control">
        <el-checkbox style="margin-right: 10px;" v-model="showLayer3" :disabled="isNotPm">同比反弹幅度大</el-checkbox>
      </div>
      <div class="main-control">
        <el-checkbox style="margin-right: 10px;" v-model="showLayer4" :disabled="isNotPm">浓度上升前期快后期慢</el-checkbox>
      </div>
      <!-- <div class="main-control">
        <el-checkbox style="margin-right: 10px;" v-model="showLayer5" :disabled="isNotPm">网格验证</el-checkbox>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from 'moment'
import { edfData1, edfData2, edfData3, edfData4, edfData5 } from './api'
import { drawGridBase } from './draw'
export default {
  name: "levelsLayer",
  props: {
    map: Object,
    data_type: String
  },
  data() {
    return {
      timeMode: false,
      time_type_local: 'week',
      line_t_local: moment(),
      canvasLayer: null,
      ctx: null,

      showLayer1: false,
      showLayer2: false,
      showLayer3: false,
      showLayer4: false,
      showLayer5: false,

      data1: null,
      data2: null,
      data3: null,
      data4: null,
      data5: null,
      showGridName: false,
    }
  },
  computed: {
    ...mapState([
      "line_t",
      "time_type"
    ]),
    isNotPm() {
      return this.data_type != 'pm25' && this.data_type != 'pm10'
    },
    line_t_data() {
      if (this.timeMode) {
        return this.line_t
      }else {
        return moment(this.line_t_local).unix() * 1000
      }
    },
    time_type_data() {
      if (this.timeMode) {
        return this.time_type
      }else {
        return this.time_type_local
      }
    }
  },
  watch: {
    line_t_data() {
      this.data1 = null
      this.data2 = null
      this.drawLayer()
      if (this.showLayer1) {
        this.getLayerData(1)
      }
      if (this.showLayer2 && this.time_type_data==='week') {
        this.getLayerData(2)
      }
    },
    time_type_data() {
      this.data1 = null
      this.data2 = null
      this.drawLayer()
      if (this.showLayer1) {
        this.getLayerData(1)
      }
      if (this.showLayer2 && this.time_type_data==='week') {
        this.getLayerData(2)
      }
    },
    data_type() {
      this.drawLayer()
    },
    showLayer1() {
      if (this.showLayer1) {
        this.getLayerData(1)
      }else {
        this.data1 = null
        this.drawLayer()
      }
    },
    showLayer2() {
      if (this.showLayer2 && this.time_type_data==='week') {
        this.getLayerData(2)
      }else {
        this.data2 = null
        this.drawLayer()
      }
    },
    showLayer3() {
      if (this.showLayer3) {
        this.getLayerData(3)
      }else {
        this.data3 = null
        this.drawLayer()
      }
    },
    showLayer4() {
      if (this.showLayer4) {
        this.getLayerData(4)
      }else {
        this.data4 = null
        this.drawLayer()
      }
    },
    showLayer5() {
      if (this.showLayer5) {
        this.getLayerData(5)
      }else {
        this.data5 = null
        this.drawLayer()
      }
    },
    showGridName() {
      this.drawLayer()
    }
  },
  
  mounted() {
    this.initLayer()
  },
  methods: {
    initLayer() {
      this.canvasLayer = new CanvasLayer({
        map: this.map,
        update: this.drawLayer,
        zIndex: 1
      });
      this.ctx = this.canvasLayer.canvas.getContext("2d");
    },
    handleTm(change) {
      let tp = this.time_type_local
      if (tp == 'week') {
        tp = 'day'
      }
      this.line_t_local = moment(this.line_t_local).add(change, tp)
    },
    async fetchLayerData(tp) {
      switch (tp) {
        case 1:
          return edfData1(this.time_type_data, this.line_t_data);
        case 2:
          return edfData2(this.line_t_data);
        case 3:
          return edfData3();
        case 4:
          return edfData4();
        case 5:
          return edfData5()
        default:
          throw new Error(`Invalid layer index: ${tp}`);
      }
    },
    async getLayerData(tp) {
      try {
        const res = await this.fetchLayerData(tp)
        this[`data${tp}`] = res.data
      }catch(e) {
        console.log(e);
        this.$message.error('获取数据失败')
        this[`data${tp}`] = null
      }
      this.drawLayer()
    },
    drawLayer() {
      this.ctx.clearRect(0,0,document.body.clientWidth, document.body.clientHeight)
      const fill = true
      let showGridName = this.showGridName

      const zoom = this.map.getZoom()
      const allGrid = [this.data1, this.data2, this.data3, this.data4, this.data5]
      for (let idx in allGrid) {
        let grid = allGrid[idx]
        if (!grid) continue
        let gridData = grid[this.data_type].grid_coords || grid[this.data_type].source_grid
        console.log(idx == 1);
        console.log(idx);
        if (idx == 1) {
          gridData = gridData.slice(0, 10)
        }
        for (let idx1 in gridData) {
          const g = gridData[idx1]
          let gData = {
            lng: g[0],
            lat: g[1],
            hot_point: true,
          }
          if (idx == 1) {
            gData.name = grid[this.data_type].source_grid_nums[idx1]
          }
          if (idx == 2 || idx == 3) {
            console.log(g);
            gData.name = Math.round(g[2] * 10000) / 10000
            console.log(gData.name);
          }
          
          drawGridBase(
            gData, 
            this.map, 
            this.ctx, 
            fill, 
            showGridName,
            zoom
          )
        }
      }
    }
  },
}
</script>
<style scoped lang='less'>
.grid-control {
  // border: 1px solid rgba(0, 0, 0, 0.184);
  // margin-top: 10px;
  // padding-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/edf/levelsLayer.vue